// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1___6b76233fdcec7198c19","cls2":"CollapsedActivityPreview-cls2___a3ff330b0b22fa5f031 CollapsedActivityPreview-cls1___6b76233fdcec7198c19"};